<template>
  <div>
    <div class="difcc" style="height: 65vh;" v-if="isSign">
      <!--审核成功-->
      <el-result v-if="type===2" icon="success" title="审核成功" subTitle="恭喜您审核通过"></el-result>
      <!--审核失败-->
      <el-result v-if="type===3" icon="error" title="审核失败" subTitle="请重新提交"></el-result>
      <!--审核中-->
      <el-result v-if="type===1" icon="info" title="审核中" subTitle="请耐心等待"></el-result>
    </div>
    <!--未报名-->
    <div v-else class="difcc" style="height: 65vh;">
      <el-result icon="info" title="尚未报名" subTitle="点击前往报名">
        <div slot="extra" class="difcc">
          <el-button type="primary" @click="goSign()">去报名</el-button>
        </div>
      </el-result>
    </div>
  </div>
</template>

<script>
export default {
  name: "findingsAudit",
  data() {
    return {
      isSign: false,
      type: 1,//1审核中 2成功 3失败
    }
  },
  methods: {
    goSign() { //去报名
      this.$router.push('/infoCenter/sign').catch(err => err)
    },
    getUserInfo() { //获取用户信息
      let user_id = JSON.parse(localStorage.getItem('jiaoyu')).id
      this.$axios("POST","/user/info",{user_id: user_id})
          .then(res => {
            if(res.code===1) {
              if(res.data.baoming_id) {
                this.isSign = true
                this.getStatus()
              }
            }
          })
    },
    getStatus() { //获取审核状态
      let user_id = JSON.parse(localStorage.getItem('jiaoyu')).id
      this.$axios("POST","/index/bmUser",{user_id: user_id},'加载中')
          .then(res => {
            if(res.code===1) {
              this.type = res.data.status
            }
          })
    },
  },
  created() {
    this.getUserInfo()
  }
}
</script>

<style scoped>

</style>